

import { GamePlan } from '@/types/gamePlanner';
import { SortOption } from './SortControls';
import { PlanTypeTabs } from './PlanTypeTabs';
import { SortControls } from './SortControls';
import { GamePlansList } from './GamePlansList';
import { SearchInput } from './SearchInput';
import { useIsMobile } from '@/hooks/use-mobile';

interface PlanListSectionProps {
  activeTab: 'templates' | 'myPlans';
  onTabChange: (tab: 'templates' | 'myPlans') => void;
  sortBy: SortOption;
  onSortChange: (option: SortOption) => void;
  sortedPlans: GamePlan[];
  loading: boolean;
  searchQuery: string;
  onSearchChange: (query: string) => void;
  onEdit: (id: string) => void;
  onShare: (id: string) => void;
  onDelete: (id: string) => void;
  onChangeDetails: (id: string) => void;
  onConvertToTemplate: (id: string) => void;
}

export function PlanListSection({
  activeTab,
  onTabChange,
  sortBy,
  onSortChange,
  sortedPlans,
  loading,
  searchQuery,
  onSearchChange,
  onEdit,
  onShare,
  onDelete,
  onChangeDetails,
  onConvertToTemplate
}: PlanListSectionProps) {
  const isMobile = useIsMobile();
  
  return (
    <>
      <div className="flex flex-col gap-4 mb-6">
        {/* Center the tabs and sort controls on desktop */}
        <div className={`flex ${isMobile ? 'justify-between' : 'justify-center'} items-center`}>
          <div className="flex items-center space-x-8">
            <PlanTypeTabs activeTab={activeTab} onTabChange={onTabChange} />
            <SortControls sortBy={sortBy} onSortChange={onSortChange} />
          </div>
        </div>
        
        <SearchInput 
          value={searchQuery} 
          onChange={onSearchChange} 
          placeholder="Search game plans..."
        />
      </div>
      
      <GamePlansList
        gamePlans={sortedPlans}
        loading={loading}
        onEdit={onEdit}
        onShare={onShare}
        onDelete={onDelete}
        onChangeDetails={onChangeDetails}
        onConvertToTemplate={onConvertToTemplate}
      />
    </>
  );
}
